export default __webpack_public_path__ + "static/media/weather.1525c281.jfif";